import { apiFetch } from '../utils/api';

export interface Banner {
  id: string;
  imageUrl: string;
  actionUrl: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedBannersResponse {
  data: Banner[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchBanners = (params: { page?: number; limit?: number; search?: string; status?: 'active' | 'inactive' | 'all' } = {}): Promise<PaginatedBannersResponse> => {
  const sp = new URLSearchParams();
  if (params.page) sp.set('page', String(params.page));
  if (params.limit) sp.set('limit', String(params.limit));
  if (params.search) sp.set('search', params.search);
  if (params.status) sp.set('status', params.status);
  const query = sp.toString();
  return apiFetch<PaginatedBannersResponse>(`/banners${query ? `?${query}` : ''}`);
};

export const fetchActiveBanners = (): Promise<Banner[]> =>
  apiFetch<Banner[]>(`/banners/active`);

export const createBanner = (payload: { imageUrl: string; actionUrl?: string; isActive?: boolean }): Promise<Banner> =>
  apiFetch<Banner>(`/banners`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateBanner = (id: string, payload: { imageUrl?: string; actionUrl?: string | null; isActive?: boolean }): Promise<Banner> =>
  apiFetch<Banner>(`/banners/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const deleteBanner = (id: string): Promise<{ success: true }> =>
  apiFetch<{ success: true }>(`/banners/${id}`, {
    method: 'DELETE',
  });
